// src/lib/lineAuthApi.js
// LINEログイン・電話番号認証まわりの callable ラッパ（実体は Core: ~/suomi-admin/functions）。
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
// ⚠LINE から開かれる画面で呼ぶものは Auth を持たない app を使う。
//   既定の app の callable は Auth の初期化完了を待ち、LINE の webview では
//   そこで止まってリクエストが1本も出ない（src/firebasePublic.js の説明参照）。
import { publicFunctions } from "../firebasePublic";

/**
 * LIFFアクセストークンでログインを試みる（未ログインで呼べる）。
 * 登録済み → { registered: true, customToken }
 * 未登録   → { registered: false, displayName }（アカウントは作られない）
 * ⚠アカウントを作る鍵は電話番号だけ。未登録なら電話番号+SMS認証へ進ませる。
 */
export async function loginWithLine({ tenantId, accessToken }) {
  const res = await httpsCallable(publicFunctions, "loginWithLine")({ tenantId, accessToken });
  return res.data;
}

/**
 * LINE連携の開始。ログイン中のこの端末でワンタイムチケットを発行する。
 * LINEアプリ内ブラウザには Firebase のセッションが無いため、誰のアカウントに繋ぐのかを
 * このチケットで運ぶ（10分・1回限り）。
 */
export async function startLineLink({ tenantId }) {
  const res = await httpsCallable(functions, "startLineLink")({ tenantId });
  return res.data;
}

/**
 * ログイン済み（SMSで入った）アカウントに LINE を連携する。
 *
 * 呼び方が2通りある:
 * - `linkTicket` あり … 外部ブラウザでログイン中の人が LINE へ飛んだ場合。LIFF 側に
 *   Firebase のセッションが無いので、チケットで「誰のアカウントか」を運ぶ。Auth非依存のappで呼ぶ
 * - `authed: true` … LIFF の中で SMS 認証を済ませた直後。セッションがあるので、
 *   Auth 付きの app で呼んで request.auth.uid を使わせる
 */
export async function linkLineToCurrentUser({ tenantId, accessToken, spaceId, linkTicket, authed = false }) {
  const target = authed ? functions : publicFunctions;
  const res = await httpsCallable(target, "linkLineToCurrentUser")({
    tenantId,
    accessToken,
    ...(spaceId ? { spaceId } : {}),
    ...(linkTicket ? { linkTicket } : {}),
  });
  return res.data;
}

/**
 * 電話番号の保存と認証状態の同期。
 * phone を渡すと自己申告の番号として保存し、いずれの場合も Firebase Auth の電話番号から
 * phone_verified を貼り直す（認証済みの判定はサーバーが Auth を見て決める）。
 */
export async function saveCustomerContact({ tenantId, phone, spaceId }) {
  const res = await httpsCallable(functions, "saveCustomerContact")({
    tenantId,
    ...(phone ? { phone } : {}),
    ...(spaceId ? { spaceId } : {}),
  });
  return res.data;
}
